import moment from 'moment-timezone';

import { IAddress } from '../../types/Address';
import { IEscrowMember, ISettlementTeam } from '../../types/Parties';
import { CompanyType } from '../constants/companyTypes';
import { IAuthState } from '../redux-store/auth/authTypes';
import { IImportedData, IManualOrder } from './../../types/ManualOrder.d';
import { IOrderType } from './../../types/OrderOverview.d';

export const getModel = (
  userOffices: IAuthState['userOffices'],
  loanNumber?: string,
  orderType?: IOrderType,
  importedData?: IImportedData,
  currentUser?: IAuthState['currentUser']
): IManualOrder => {
  function generateOrderID() {
    let id =
      currentUser?.tenant_id +
      '-FN' +
      Math.floor(1000 + Math.random() * 9999999);
    id += 'R200-';

    id += makeid(8);
    return id;
  }

  function makeid(length: number) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const addUserToEscrowTeam: IEscrowMember = {
    Id: 'custom_' + Date.now(),
    FirstName: currentUser?.given_name ? currentUser.given_name : '',
    LastName: currentUser?.family_name ? currentUser.family_name : '',
    Type: 'Loan Closer',
    Addresses: [],
    PhoneNumbers: [
      {
        CountryCode: '1',
        AreaCode: '000',
        Number: '0000000',
        Extension: null,
        Type: 'Cellular',
      },
    ],
    Emails: currentUser?.email ? [currentUser.email.toLowerCase()] : [],
  };

  const addSettlementTeam: ISettlementTeam[] = [
    {
      Id: '0',
      FirstName: '',
      LastName: '',
      Type: CompanyType.SettlementCompany,
      PhoneNumbers: [],
      Emails: [],
    },
  ];

  let importData: IImportedData;
  if (importedData) {
    const update = JSON.parse(JSON.stringify(importedData));
    update?.escrowTeam?.unshift(addUserToEscrowTeam);
    importData = update;
  } else {
    importData = {
      escrowTeam: [addUserToEscrowTeam],
      signers: [],
      loanType: '',
      properties: [
        {
          Addresses: [
            {
              Line1: '',
              Line2: '',
              Line3: '',
              State: {
                Name: '',
                Code: '',
              },
              ZipCode: '',
              City: '',
              County: '',
              Type: null,
            } as IAddress,
          ],
          PropertyType: 'Single Family',
        },
      ],
    };
  }

  let obj = {
    ManualOrder: true,
    TransactionType: orderType?.Name,
    Region: userOffices?.HomeRegion
      ? userOffices?.HomeRegion
      : { Id: 410, Name: 'California' },
    OrderOverview: {
      Properties: importData.properties,
      Signers: importData.signers,
      EscrowTeam: importData.escrowTeam,
      SettlementTeam: addSettlementTeam,
      NewLoans: [
        {
          LoanNumber: String(loanNumber),
          Lender: {
            Id: 0,
            Name: importData.lenderName,
            SalesRepOne: null,
            SalesRepTwo: null,
            Addresses: [],
          },
          Type: importData.loanPurpose,
        },
      ],
      Documents: [],
    },
    OrderDetails: {
      SigningDate: JSON.parse(JSON.stringify(moment().toDate())),
      OrderType: orderType,
      Signers: importData.signers,
      EscrowTeam: importData.escrowTeam,
      SettlementTeam: addSettlementTeam,
      Documents: [],
    },
    OfficeId: userOffices?.HomeOffice?.Id
      ? String(userOffices.HomeOffice.Id)
      : '539',
    OfficeName: userOffices?.HomeOffice?.Name
      ? userOffices.HomeOffice.Name
      : 'CA BAY San Carlos Escrow',
    Id: generateOrderID(),
  };

  if (currentUser && currentUser.tenant_id === 'DOCU') {
    obj = Object.assign({}, obj, { ClientId: 'C777' });
  }

  return obj;
};
